/**
 * Created by Denis Kuzin on 29 march 2022
 */

const AddClanWindow = CleverappsWindow.extend({
    onWindowLoaded: function (userClan) {
        this.userClan = userClan;

        this.clanEmblem = userClan && userClan.emblem || 1;
        this.clanName = userClan && userClan.name || "";
        this.clanLevel = userClan && userClan.requiredLevel || ClansConfig.MIN_REQUIRED_LEVEL;

        this.emblemsAmount = 0;
        while (bundles.clan_banner.frames[`emblem_${this.emblemsAmount + 1}`]) {
            this.emblemsAmount++;
        }

        this._super({
            name: "AddClanWindow",
            content: this.createContent(),
            title: Messages.get(this.userClan ? "AddClanWindow.editingTeam.title" : "AddClanWindow.creatingTeam.title")
        });
        this.updateState();
    },

    createContent: function () {
        const styles = cleverapps.styles.AddClanWindow;

        const content = new cc.Node();
        content.setContentSize2(styles);

        const background = cleverapps.UI.createScale9Sprite(bundles.clan.frames.table_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize2(styles.background.width, styles.background.height);
        background.setAlignment(styles.background);
        content.addChild(background);

        const emblem = this.createEmblem();
        emblem.setAlignment(styles.emblem);
        background.addChild(emblem);

        const name = this.createName();
        name.setAlignment(styles.name);
        background.addChild(name);

        const settings = this.createSettings();
        settings.setAlignment(styles.settings);
        background.addChild(settings);

        const footerButton = this.createFooterButtons();
        footerButton.setAlignment(styles.footerButton);
        content.addChild(footerButton);

        return content;
    },

    createEmblem: function () {
        const styles = cleverapps.styles.AddClanWindow.emblem;

        const emblemSelection = cleverapps.UI.createScale9Sprite(bundles.clans_window.frames.selector_background, cleverapps.UI.Scale9Rect.TwoPixelXY);
        emblemSelection.setContentSize2(styles.width, styles.height);

        const changeLink = new cc.Node();

        const changeText = cleverapps.UI.generateOnlyText(Messages.get("AddClanWindow.edit"), cleverapps.styles.FONTS.CLAN_CHANGE_EMBLEM_TEXT);
        changeLink.addChild(changeText, 1);

        if (styles.underline) {
            changeLink.addChild(cleverapps.UI.drawUnderline(changeText, styles.underline));
        }

        cleverapps.UI.wrap(changeLink);

        const emblem = new cc.Sprite(bundles.clan_banner.frames[`emblem_${this.clanEmblem}`]);

        const layout = new cleverapps.Layout([changeLink, emblem], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
        layout.setAlignment(styles.icon);
        emblemSelection.addChild(layout);

        const onClick = function (step) {
            this.clanEmblem += step;
            if (this.clanEmblem > this.emblemsAmount) {
                this.clanEmblem = 1;
            } else if (this.clanEmblem < 1) {
                this.clanEmblem = this.emblemsAmount;
            }
            emblem.setSpriteFrame(bundles.clan_banner.frames[`emblem_${this.clanEmblem}`]);
            this.updateState();
        }.bind(this);

        cleverapps.UI.onClick(changeLink, onClick.bind(this, 1));

        return new cleverapps.Layout([this.getArrow(true, onClick.bind(this, -1)), emblemSelection, this.getArrow(false, onClick.bind(this, 1))], {
            direction: cleverapps.UI.HORIZONTAL
        });
    },

    createName: function () {
        const styles = cleverapps.styles.AddClanWindow.name;

        const bg = cleverapps.UI.createScale9Sprite(bundles.clans_window.frames.selector_background, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize2(styles.width, styles.height);

        const placeholder = cleverapps.UI.generateOnlyText(Messages.get("AddClanWindow.teamNamePlaceholder"), cleverapps.styles.FONTS.CLAN_EDIT_TEXT);
        placeholder.setDimensions(styles.text.width, styles.height);
        placeholder.setAlignment(styles.text.placeholder);
        placeholder.setOpacity(140);
        bg.addChild(placeholder);

        const text = new cc.EditBox(cc.size(styles.text.width, styles.text.height), undefined, true);
        text.setMaxLength(styles.text.maxLength);
        text.setString(" ");
        text.setDelegate(this);
        text.stayOnTop(true);
        text.setTouchEnabled();
        text.setFontSize(cleverapps.styles.FONTS.CLAN_EDIT_TEXT.size);
        text.setFontColor(cleverapps.styles.FONTS.CLAN_EDIT_TEXT.color);
        text.setFontName(cleverapps.UI.getFontName());
        text.setString(this.clanName);
        text.setAlignment(bg.width / 2, bg.height / 2 + styles.text.offsetY);
        text.customPlaceholder = placeholder;
        bg.addChild(text);

        if (this.userClan) {
            placeholder.setVisible(false);
        }

        this.clanNameEditbox = text;

        const label = cleverapps.UI.generateOnlyText(Messages.get("AddClanWindow.teamNameLabel"), cleverapps.styles.FONTS.CLAN_PROPERTY_TEXT);
        label.fitTo(styles.label.width);

        return new cleverapps.Layout([label, bg], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
    },

    createSettings: function () {
        const styles = cleverapps.styles.AddClanWindow.settings;

        const getItem = function (label, values, idx, updater) {
            const settingName = cleverapps.UI.generateOnlyText(label, cleverapps.styles.FONTS.CLAN_PROPERTY_TEXT);
            settingName.setDimensions(styles.label.width, styles.label.height);

            const bg = cleverapps.UI.createScale9Sprite(bundles.clans_window.frames.selector_background, cleverapps.UI.Scale9Rect.TwoPixelXY);
            bg.setContentSize2(styles.bg.width, styles.bg.height);

            const text = cleverapps.UI.generateOnlyText(values[idx].text, cleverapps.styles.FONTS.CLAN_SETTING_TEXT);
            text.fitTo(styles.text.width);
            text.setAlignment(bg.width / 2, bg.height / 2);
            bg.addChild(text);

            updater(values[idx].value);

            const onClick = function (step) {
                idx += step;
                idx = Math.max(0, Math.min(values.length - 1, idx));

                text.setString(values[idx].text);
                updater(values[idx].value);

                this.updateState();
            }.bind(this);

            const leftArrow = this.getArrow(true, onClick);
            const rightArrow = this.getArrow(false, onClick);

            const settingValue = new cleverapps.Layout([leftArrow, bg, rightArrow], {
                direction: cleverapps.UI.HORIZONTAL
            });

            return new cleverapps.Layout([settingName, settingValue], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.row.margin
            });
        }.bind(this);

        const availableLevels = [];
        let currentLevelIdx = 0;
        let level = ClansConfig.MIN_REQUIRED_LEVEL;
        do {
            availableLevels.push({ text: level, value: level });
            if (level === this.clanLevel) {
                currentLevelIdx = availableLevels.length - 1;
            }
            level++;
        } while (level <= cleverapps.gameLevel.getLevel() && level <= ClansConfig.MAX_REQUIRED_LEVEL);

        const requiredLevel = getItem(Messages.get("AddClanWindow.requiredLevel"), availableLevels, currentLevelIdx, (value) => {
            this.clanLevel = value;
        });

        return new cleverapps.Layout([requiredLevel], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    getArrow: function (reverse, onClick) {
        const button = new cleverapps.UI.Button({
            type: {
                button_png: bundles.clans_window.frames.selector_arrow,
                button_on_png: bundles.clans_window.frames.selector_arrow,
                button_off_png: bundles.clans_window.frames.selector_arrow
            },
            onClicked: function () {
                onClick(reverse ? -1 : 1);
            }
        });

        if (reverse) {
            button.baseScaleX = -1;
            button.baseScaley = 1;
            button.setScaleX(-1);
        }

        return button;
    },

    createFooterButtons: function () {
        const styles = cleverapps.styles.AddClanWindow.footerButton;
        const text = this.userClan ? `${Messages.get("Edit")}$$ ${ClansConfig.EDITING_PRICE}`
            : `${Messages.get("Create")}$$ ${ClansConfig.CREATION_PRICE}`;

        this.createButton = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            type: cleverapps.styles.UI.Button.Images.button_blue,
            text,
            disabled: true,
            onClicked: function () {
                cleverapps.clans.create({
                    clanId: this.userClan && this.userClan.id,
                    name: this.clanNameEditbox.getString(),
                    emblem: this.clanEmblem,
                    requiredLevel: this.clanLevel
                });
            }.bind(this)
        });

        return this.createButton;
    },

    updateState: function () {
        if (!this.createButton) {
            return;
        }

        let tooltip;

        const str = this.clanNameEditbox.getString();
        if (!str) {
            tooltip = "AddClanWindow.emptyNameTooltip";
        } else if (/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g.test(str)) {
            tooltip = "AddClanWindow.invalidNameTooltip";
        } else if (this.userClan && str === this.userClan.name && this.clanEmblem === this.userClan.emblem && this.userClan.requiredLevel === this.clanLevel) {
            tooltip = "AddClanWindow.noChangesToEdit";
        }

        cleverapps.tooltipManager.remove(this.createButton);

        if (!tooltip) {
            this.createButton.enable();
            return;
        }

        this.createButton.disable();
        cleverapps.tooltipManager.create(this.createButton, {
            text: Messages.get(tooltip)
        });
    },

    onHide: function () {
        this._super();
        this.clanNameEditbox.stayOnTop(false);
    },

    onShow: function () {
        this._super();
        this.clanNameEditbox.stayOnTop(true);
    },

    editBoxEditingDidBegin: function (sender) {
        sender.customPlaceholder.setVisible(false);
    },

    editBoxEditingDidEnd: function (sender) {
        if (sender.getString() === "") {
            sender.customPlaceholder.setVisible(true);
        }
    },

    editBoxTextChanged: function (sender, text) {
        if (text === "\n") {
            sender.setString(this._tmpText || "");
        }

        this.updateState();
    },

    editBoxReturn: function (sender) {
        this._tmpText = sender.getString();

        sender.setString("");
    }
});

cleverapps.styles.AddClanWindow = {
    width: 1280,
    height: 730,

    background: {
        width: 1340,
        height: 570,
        x: { align: "center" },
        y: { align: "top" }
    },

    footerButton: {
        width: 400,
        height: 100,
        x: { align: "center" },
        y: { align: "bottom", dy: 20 }
    },

    emblem: {
        width: 300,
        height: 300,
        x: { align: "left", dx: 75 },
        y: { align: "bottom", dy: 50 },
        icon: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        },
        underline: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -18 },
            height: 2
        },
        margin: 8
    },

    name: {
        width: 750,
        height: 100,
        margin: 85,
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: -50 },

        label: {
            width: 430
        },

        text: {
            maxLength: 25,
            width: 690,
            height: 72,
            offsetY: 4,

            placeholder: {
                x: { align: "left", dx: 35 },
                y: { align: "center", dy: 2 }
            },

            regular: {
                x: { align: "left", dx: 35 },
                y: { align: "center", dy: 4 }
            }
        }
    },

    settings: {
        margin: 20,
        x: { align: "right", dx: -90 },
        y: { align: "bottom", dy: 50 },

        bg: {
            width: 300,
            height: 100
        },

        row: {
            margin: 50
        },

        label: {
            width: 350,
            height: 100
        },

        text: {
            width: 280
        }
    }
};